// ========================
// Константы кредитного калькулятора
// ========================

// Диапазоны сумм кредита
export const PDL_MIN_LOAN_AMOUNT = 10_000;
export const INSTALLMENT_MIN_LOAN_AMOUNT = 50_000;
export const INSTALLMENT_MAX_LOAN_AMOUNT = 700_000;
export const DEFAULT_LOAN_AMOUNT = 100_000;
export const LOAN_AMOUNT_STEP = 10_000;

// Дизайн-токены ставок
export const DEFAULT_INSTALLMENT_RATE = 0.3796; // 37.96% годовых
export const DEFAULT_PDL_DAILY_RATE = 0.00104; // 37,96% годовых / 365 дней = 0.00104 в день (доля единицы)

// Селекторы
export const CALC_SLIDER_RAIL_SELECTOR = ".calc__slider-rail";
export const DISPLAY_VALUE_TEXT_SELECTOR = ".display-value__text";
export const PERIOD_SELECT_SELECTOR = "select[name='period']";
export const REPAYMENT_SELECT_SELECTOR = "select[name='offline_points']";
export const RESULT_VALUES_SELECTOR = ".calc__result-value";
export const MONTHLY_PAYMENT_ITEM_SELECTOR = "[data-result='monthly-payment']";
export const END_OF_TERM_OPTION_SELECTOR = "option[value='end_of_term']";
export const MIN_MAX_TEXT_SELECTOR = ".min-max-block";
export const CALC_TYPE_ATTRIBUTE = "data-calc-type";

// Маппинг периодов в дни и месяцы
export const PERIOD_MAPPING = {
  "7_day": { days: 7, months: 0, isDays: true, maxAmount: 150_000 },
  "14_day": { days: 14, months: 0, isDays: true, maxAmount: 300_000 },
  "21_day": { days: 21, months: 0, isDays: true, maxAmount: 300_000 },
  "25_day": { days: 25, months: 0, isDays: true, maxAmount: 300_000 },
  "6_month": { days: 0, months: 6, isDays: false },
  "12_month": { days: 0, months: 12, isDays: false },
  // "24_month": { days: 0, months: 24, isDays: false },
  // "36_month": { days: 0, months: 36, isDays: false },
  // "48_month": { days: 0, months: 48, isDays: false },
  // "60_month": { days: 0, months: 60, isDays: false },
};
